import React from "react";

import { Button } from "antd";

import { ReactComponent as Arrow } from "../../../../assets/images/common/LeftArrowRounded.svg";
import "./InviteButton.css";

export default function InviteButton({
  isSendingInvite, handleSubmit,
}) {
  return (
    <Button
      type="primary"
      htmlType="submit"
      onClick={isSendingInvite ? null : handleSubmit}
      loading={isSendingInvite}
      className="signup-invite-invite-btn"
      icon={<Arrow className="SignupInvite__InviteButton__Arrow" />}
    >
      {isSendingInvite ? "Sending Invite" : "Send Invite"}
    </Button>
  );
}
